import React, { Component } from 'react';
import './custom.css';
import logo from '../../assets/images/NN Logo Final-01.jpg';
import axios from 'axios';
import { DISPATCH_BASE_URL } from '../../util/constants';

import CompanyIdentificationModal from './CompanyIdentificationModal';
import { validateCompany, extractSubdomain } from '../../actions/companyActions';

/**
 * Custom Component — Landing Page / Marketing Site
 * ─────────────────────────────────────────────────────
 * CHANGES:
 *  1. Removed unused imports (Link, getAxiosInstance)
 *  2. Cleaned up inline styles
 *  3. Consistent event handler patterns
 *  4. Added try/catch on form submission
 *  5. No layout or content changes
 */

class Custom extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formData: {
        fullName: '',
        companyName: '',
        emailAddress: '',
        phoneNumber: '',
        businessSize: '',
      },
      isSubmitting: false,
      submitSuccess: false,
      submitError: null,
      formErrors: {},
      showCompanyModal: false,
    };
  }

  handleInputChange = (e) => {
    const { name, value } = e.target;
    this.setState((prevState) => ({
      formData: { ...prevState.formData, [name]: value },
      formErrors: { ...prevState.formErrors, [name]: '' },
    }));
  };

  validateForm = () => {
    const { formData } = this.state;
    const errors = {};

    if (!formData.fullName.trim()) {
      errors.fullName = 'Full Name is required';
    }
    if (!formData.companyName.trim()) {
      errors.companyName = 'Company Name is required';
    }
    if (!formData.emailAddress.trim()) {
      errors.emailAddress = 'Email Address is required';
    } else if (!/\S+@\S+\.\S+/.test(formData.emailAddress)) {
      errors.emailAddress = 'Email Address is invalid';
    }

    return errors;
  };

  handleSubmit = async (e) => {
    e.preventDefault();

    const errors = this.validateForm();
    if (Object.keys(errors).length > 0) {
      this.setState({ formErrors: errors });
      return;
    }

    this.setState({ isSubmitting: true, submitError: null, submitSuccess: false });

    try {
      const response = await axios.post(
        `${DISPATCH_BASE_URL}onboarding/waitlist/join`,
        this.state.formData
      );

      if (response.data.statusCode === 200) {
        this.setState({
          submitSuccess: true,
          isSubmitting: false,
          formData: {
            fullName: '',
            companyName: '',
            emailAddress: '',
            phoneNumber: '',
            businessSize: '',
          },
        });

        setTimeout(() => {
          this.setState({ submitSuccess: false });
        }, 5000);
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      this.setState({
        submitError:
          error.response?.data?.statusMsg || 'Failed to submit. Please try again.',
        isSubmitting: false,
      });
    }
  };

  handleSignInClick = (e) => {
    e.preventDefault();
    this.setState({ showCompanyModal: true });
  };

  handleCloseModal = () => {
    this.setState({ showCompanyModal: false });
  };

  handleCompanyValidation = async (identificationType, value) => {
    try {
      let processedValue = value;
      if (identificationType === 'domain') {
        const extracted = extractSubdomain(value);
        if (extracted) {
          processedValue = extracted;
        }
      }

      const result = await validateCompany(identificationType, processedValue);

      if (result.success && result.subdomain) {
        const protocol = window.location.protocol;
        const mainDomain = window.location.hostname.split('.').slice(-2).join('.');
        const port = window.location.port ? `:${window.location.port}` : '';
        window.location.href = `${protocol}//${result.subdomain}.${mainDomain}${port}/login`;
      } else {
        throw new Error('Invalid response from server');
      }
    } catch (error) {
      throw error;
    }
  };

  render() {
    const { formData, isSubmitting, submitSuccess, submitError, formErrors, showCompanyModal } =
      this.state;

    return (
      <>
        <CompanyIdentificationModal
          isOpen={showCompanyModal}
          onClose={this.handleCloseModal}
          onValidate={this.handleCompanyValidation}
        />

        <div className="home">
          <header className="site-header" id="top">
            <div>
              <a href="#top" className="site-logo-text">
                <img src={logo} alt="navinet" className="block-center img-rounded" />
              </a>
            </div>
            <div className="row">
              <nav className="navbar navbar-expand-sm bg-light">
                <div className="container-fluid justify-content-between">
                  <ul className="navbar-nav">
                    <li><a className="site-link ml-3" href="#features">Product</a></li>
                    <li><a className="site-link ml-3" href="#about">About Us</a></li>
                    <li><a className="site-link ml-3" href="#contact">Contact</a></li>
                  </ul>
                </div>
              </nav>
            </div>
            <div className="text-right mr-10">
              <a
                className="site-link chip"
                href="#signin"
                onClick={this.handleSignInClick}
              >
                Sign In
              </a>
              <a className="site-link chip ml-2" href="#contact">get navinet</a>
            </div>
          </header>

          <div className="row">
            <div className="banner-content pt-5">
              <div className="banner-content">
                <div className="d-flex align-items-center justify-content-center">
                  <div className="chip" style={{ marginTop: '2%' }}>
                    <h4>Powerful Towing &amp; Impound Software</h4>
                  </div>
                </div>
                <h4 className="ml-4 mt-4">
                  Towing &amp; Impound Software for Easy Dispatch and Storage
                </h4>
                <p className="ml-4">
                  Built by a towing company for towing companies, NaviNet simplifies dispatch,
                  impounds, billing, and storage &mdash; all in one cloud-based system.
                </p>
                <div>
                  <a className="link-underline-hover ml-4" href="#contact">
                    Get Early Access to Our Powerful Towing Software
                  </a>
                </div>
              </div>
            </div>
          </div>

          <section className="app-img">
            <div className="app-img-main">
              <img src={require('../../assets/images/app.jpg')} alt="NaviNet App" />
            </div>
          </section>

          <section className="experience" id="experience">
            <div className="container">
              <div className="d-flex align-items-center justify-content-center">
                <div className="chip"><h4>WHY NAVINET</h4></div>
              </div>
              <div className="row justify-content-center">
                <div className="col-lg-8">
                  <h2 className="text-center text-black pt-3">
                    Experience the power of seamless functionality
                  </h2>
                </div>
              </div>
              <div className="row justify-content-center">
                <div className="col-lg-6">
                  <p className="text-center text-grey pt-4">
                    Streamline towing, impound, dispatch, and vehicle storage with our powerful,
                    automated software.
                  </p>
                </div>
              </div>
              <div className="row g-45 mt-3">
                <div className="col-sm-6 col-lg-4">
                  <div className="exp-card">
                    <div className="exp-icon">
                      <img src={require('../../assets/images/automate.svg')} alt="" />
                    </div>
                    <h3>Automate Towing &amp; Impound Management</h3>
                    <p>From dispatch to release, reduce manual entry and let NaviNet handle the workflow.</p>
                  </div>
                </div>
                <div className="col-sm-6 col-lg-4">
                  <div className="exp-card" style={{ height: '93%' }}>
                    <div className="exp-icon">
                      <img src={require('../../assets/images/minimize.svg')} alt="" />
                    </div>
                    <h3>Minimize Errors &amp; Save Time</h3>
                    <p>Set rate plans and rules once. NaviNet applies them consistently, every time.</p>
                  </div>
                </div>
                <div className="col-sm-12 col-lg-4">
                  <div className="exp-card">
                    <div className="exp-icon">
                      <img src={require('../../assets/images/streamline.svg')} alt="" />
                    </div>
                    <h3>Streamline Vehicle Storage &amp; Releases</h3>
                    <p>Track inventory, manage storage timelines, and process vehicle releases with ease.</p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="features" id="features">
            {/* Features section content */}
          </section>

          <section className="about" id="about">
            <div className="container">
              <div className="row align-items-center justify-content-between about-secN row-gap-5">
                <div className="col-sm-6">
                  <img src={require('../../assets/images/about.png')} alt="About NaviNet" />
                </div>
                <div className="col-sm-6 col-lg-5">
                  <div className="d-flex align-items-center">
                    <div className="chip">ABOUT US</div>
                  </div>
                  <h2 className="pt-4">A System Built by Towers, for Towers</h2>
                  <p className="pt-4">
                    NaviNet was created inside a working towing business &mdash; not in a boardroom.
                    It&apos;s tailored to real-world needs and refined through years of hands-on use.
                  </p>
                  <p className="pt-4">
                    You&apos;ll get a platform that works the way you do &mdash; without the fluff.
                  </p>
                  <a className="site-link yellow text-uppercase mt-5 anchor" href="#contact">
                    Get Notified
                  </a>
                </div>
              </div>
            </div>
          </section>

          <section className="access" id="access">
            <div className="container">
              <div className="access-card">
                <div className="d-flex align-items-center justify-content-center">
                  <div className="chip">get access</div>
                </div>
                <div className="row justify-content-center">
                  <div className="col-lg-9">
                    <h2 className="text-center text-green pt-3">
                      Reduce Errors &amp; Boost Efficiency{' '}
                      <span className="text-white">with NaviNet</span>
                    </h2>
                  </div>
                </div>
                <div className="row justify-content-center">
                  <div className="col-lg-8">
                    <p className="text-center pt-4">
                      Automate daily tasks, speed up dispatch, and keep your office running smoothly
                      &mdash; all from one cloud-based dashboard.
                    </p>
                  </div>
                </div>
                <a className="site-link yellow text-uppercase mt-5 anchor" href="#contact">
                  Get Early Access to Our Powerful Towing Software
                </a>
              </div>
            </div>
          </section>

          <section className="contact" id="contact">
            <div className="container">
              <div className="d-flex align-items-center justify-content-center">
                <div className="chip bg-grey">JOIN WAITING LIST</div>
              </div>
              <div className="row justify-content-center">
                <div className="col-lg-8">
                  <h2 className="text-center pt-3">Get Early Access to NaviNet!</h2>
                </div>
              </div>
              <div className="row justify-content-center">
                <div className="col-lg-5">
                  <p className="text-center pt-4">
                    Be the first to know when NaviNet is live. Sign up now and we&apos;ll reach out
                    when the software is ready.
                  </p>
                </div>
              </div>

              {submitSuccess && (
                <div className="row justify-content-center">
                  <div className="col-sm-7">
                    <div className="alert alert-success" role="alert">
                      <strong>Success!</strong> Thank you for joining our waitlist. We&apos;ll be in
                      touch soon!
                    </div>
                  </div>
                </div>
              )}

              {submitError && (
                <div className="row justify-content-center">
                  <div className="col-sm-7">
                    <div className="alert alert-danger" role="alert">
                      <strong>Error!</strong> {submitError}
                    </div>
                  </div>
                </div>
              )}

              <div className="row justify-content-center g-5 pt-5 align-items-center">
                <div className="col-sm-7">
                  <form onSubmit={this.handleSubmit}>
                    <div className="row g-4">
                      <div className="col-sm-6">
                        <div className="input-wrap">
                          <label className="label">Full Name*</label>
                          <input
                            className={`input ${formErrors.fullName ? 'is-invalid' : ''}`}
                            type="text"
                            name="fullName"
                            placeholder="Please Enter Your Full Name"
                            value={formData.fullName}
                            onChange={this.handleInputChange}
                          />
                          {formErrors.fullName && (
                            <div className="invalid-feedback d-block">{formErrors.fullName}</div>
                          )}
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="input-wrap">
                          <label className="label">Company Name*</label>
                          <input
                            className={`input ${formErrors.companyName ? 'is-invalid' : ''}`}
                            type="text"
                            name="companyName"
                            placeholder="Please Enter Your Company Name"
                            value={formData.companyName}
                            onChange={this.handleInputChange}
                          />
                          {formErrors.companyName && (
                            <div className="invalid-feedback d-block">{formErrors.companyName}</div>
                          )}
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="input-wrap">
                          <label className="label">Email Address*</label>
                          <input
                            className={`input ${formErrors.emailAddress ? 'is-invalid' : ''}`}
                            type="email"
                            name="emailAddress"
                            placeholder="Please Enter Your Email Address"
                            value={formData.emailAddress}
                            onChange={this.handleInputChange}
                          />
                          {formErrors.emailAddress && (
                            <div className="invalid-feedback d-block">{formErrors.emailAddress}</div>
                          )}
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="input-wrap">
                          <label className="label">Phone Number</label>
                          <input
                            className="input"
                            type="tel"
                            name="phoneNumber"
                            placeholder="Please Enter Your Phone Number"
                            value={formData.phoneNumber}
                            onChange={this.handleInputChange}
                          />
                        </div>
                      </div>
                      <div className="col-sm-12">
                        <div className="input-wrap">
                          <label className="label">Business Size</label>
                          <input
                            className="input"
                            type="text"
                            name="businessSize"
                            placeholder="Please Select Which Plan Would Work Best For Your Business"
                            value={formData.businessSize}
                            onChange={this.handleInputChange}
                          />
                        </div>
                      </div>
                      <div className="col-sm-12">
                        <div className="input-wrap">
                          <button
                            type="submit"
                            className="site-link yellow w-100"
                            disabled={isSubmitting}
                          >
                            {isSubmitting ? 'Submitting\u2026' : 'Join Waiting List'}
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                  <p className="pt-3">
                    By clicking join waiting list, you agree to our Terms and have read and
                    acknowledge the Privacy Policy.
                  </p>
                </div>
              </div>
            </div>
          </section>

          <section className="faq" id="faq">
            <div className="container">
              <div className="d-flex align-items-center justify-content-center">
                <div className="chip">FAQ</div>
              </div>
              <h2 className="text-center pt-3">Frequently Asked Questions</h2>
              <p className="text-center pt-4">
                Find answers to the most common questions about NaviNet,
              </p>
              <div className="question">
                <div className="accordion" id="faqAccordion">
                  <div className="row" style={{ marginLeft: '15%' }}>
                    <div className="col-lg-4">
                      <div className="card">
                        <div className="card-header" id="headingOne">
                          <h5 className="mb-0">
                            <button
                              className="btn btn-link collapsed"
                              type="button"
                              data-toggle="collapse"
                              data-target="#collapseOne"
                              aria-expanded="false"
                              aria-controls="collapseOne"
                            >
                              Is NaviNet being used today?
                            </button>
                          </h5>
                        </div>
                        <div id="collapseOne" className="collapse" aria-labelledby="headingOne" data-parent="#faqAccordion">
                          <div className="card-body">
                            <p>Yes, it&apos;s been used internally at All City Towing since 2016. We&apos;re now preparing to release it to the public.</p>
                          </div>
                        </div>
                      </div>
                      <div className="card" style={{ marginTop: '10px' }}>
                        <div className="card-header" id="headingTwo">
                          <h5 className="mb-0">
                            <button className="btn btn-link collapsed" type="button" data-toggle="collapse" data-target="#faq-2" aria-expanded="false" aria-controls="faq-2">
                              Can I try a demo?
                            </button>
                          </h5>
                        </div>
                        <div id="faq-2" className="collapse" aria-labelledby="headingTwo" data-parent="#faqAccordion">
                          <div className="card-body">
                            <p>A demo will be available soon. Sign up to get notified as soon as it&apos;s ready.</p>
                          </div>
                        </div>
                      </div>
                      <div className="card" style={{ marginTop: '10px' }}>
                        <div className="card-header" id="headingThree">
                          <h5 className="mb-0">
                            <button className="btn btn-link collapsed" type="button" data-toggle="collapse" data-target="#faq-3" aria-expanded="false" aria-controls="faq-3">
                              How is NaviNet priced?
                            </button>
                          </h5>
                        </div>
                        <div id="faq-3" className="collapse" aria-labelledby="headingThree" data-parent="#faqAccordion">
                          <div className="card-body">
                            <p>Pricing is per user. We&apos;ll share exact pricing with early access users.</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-8">
                      <div className="card">
                        <div className="card-header" id="headingFour">
                          <h5 className="mb-0">
                            <button className="btn btn-link collapsed" type="button" data-toggle="collapse" data-target="#faq-4" aria-expanded="false" aria-controls="faq-4">
                              Does NaviNet integrate with my GPS or accounting software?
                            </button>
                          </h5>
                        </div>
                        <div id="faq-4" className="collapse" aria-labelledby="headingFour" data-parent="#faqAccordion">
                          <div className="card-body">
                            <p>Currently, NaviNet supports Elavon credit card processing. More integrations are coming soon.</p>
                          </div>
                        </div>
                      </div>
                      <div className="card" style={{ marginTop: '10px' }}>
                        <div className="card-header" id="headingFive">
                          <h5 className="mb-0">
                            <button className="btn btn-link collapsed" type="button" data-toggle="collapse" data-target="#faq-5" aria-expanded="false" aria-controls="faq-5">
                              Is NaviNet cloud-based?
                            </button>
                          </h5>
                        </div>
                        <div id="faq-5" className="collapse" aria-labelledby="headingFive" data-parent="#faqAccordion">
                          <div className="card-body">
                            <p>Yes, it runs in any modern browser &mdash; no installs needed.</p>
                          </div>
                        </div>
                      </div>
                      <div className="card" style={{ marginTop: '10px' }}>
                        <div className="card-header" id="headingSix">
                          <h5 className="mb-0">
                            <button className="btn btn-link collapsed" type="button" data-toggle="collapse" data-target="#faq-6" aria-expanded="false" aria-controls="faq-6">
                              What size of towing companies is NaviNet for?
                            </button>
                          </h5>
                        </div>
                        <div id="faq-6" className="collapse" aria-labelledby="headingSix" data-parent="#faqAccordion">
                          <div className="card-body">
                            <p>NaviNet works for small operators and large fleets alike.</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <footer className="site-footer">
            <div className="container">
              <div className="footer-main">
                <div className="footer-left">
                  <div className="d-flex align-items-center">
                    <div className="chip">JOIN NOW</div>
                  </div>
                  <h3 className="text-green pt-3">Get On a Waiting List</h3>
                  <p className="pt-3">
                    Be the first to try NaviNet <br /> when it goes public.
                  </p>
                  <div className="d-flex flex-column gap-2 pt-4 mt-2">
                    <div className="position-relative">
                      <input className="input" type="email" placeholder="Enter Your Email Address" />
                      <span className="inp-icon">
                        <i className="bi bi-envelope fs-5 text-white" />
                      </span>
                    </div>
                    <button className="site-link yellow w-100 no-anime">Join Waiting List</button>
                  </div>
                </div>
                <div className="footer-right">
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="footer-logo">
                      <img src={require('../../assets/images/logo-white.svg')} alt="NaviNet" />
                    </div>
                    <a className="d-flex align-items-center gap-2 text-white" href="mailto:example@domain.com">
                      <i style={{ color: '#FFCB05' }} className="bi bi-envelope fs-5" /> example@domain.com
                    </a>
                  </div>
                  <div className="footer-link">
                    <div className="footer-link-single">
                      <ul>
                        <li className="pb-2">Quick Links</li>
                        <li><a href="#top">Home</a></li>
                        <li><a href="#features">Product</a></li>
                        <li><a href="#about">About Us</a></li>
                        <li><a href="#contact">Contact</a></li>
                      </ul>
                    </div>
                    <div className="footer-link-single" style={{ marginLeft: '30px' }}>
                      <ul>
                        <li className="pb-2">Authentication</li>
                        <li><a href="#contact">Login</a></li>
                        <li><a href="#contact">Sign up</a></li>
                        <li><a href="#contact">Forgot Password</a></li>
                      </ul>
                    </div>
                    <div className="footer-link-single">
                      <ul>
                        <li className="pb-2">Resources</li>
                        <li><a href="#faq">FAQ</a></li>
                        <li><a href="#about">Privacy policy</a></li>
                        <li><a href="#about">Terms &amp; Condition</a></li>
                      </ul>
                    </div>
                  </div>
                  <div>
                    <p style={{ color: '#A5ACB0' }}>&copy;2025 NaviNet</p>
                  </div>
                </div>
              </div>
            </div>
          </footer>
        </div>
      </>
    );
  }
}

export default Custom;
